import { SPELL_TARGET_TYPE, SPELL_TYPE } from './../../../c.managers/LevelManager/store.d';
import GameObject from './GameObject';
import { GAME_OBJECTS } from './types';
import { Object3D } from 'three';
export const GRAVE = {
  type: SPELL_TYPE.GRAVE,
  name: 'Cippo',
  targetType: SPELL_TARGET_TYPE.TERRAIN,
  icon: '🪦',
  cost: 2,
  description: 'Cast a blocking tombstone over the field',
}
export const SPARK = {
  type: SPELL_TYPE.SPARK,
  name: 'Lumen',
  targetType: SPELL_TARGET_TYPE.ENEMY_CREATURES,
  icon: '💥',
  cost: 2,
  description: 'Strikes enemy creature, target losts 25% of HP'
}
export const CANDY_SWORD = {
  type: SPELL_TYPE.CANDY_SWORD,
  name: 'Gladius',
  targetType: SPELL_TARGET_TYPE.MY_CREATURES,
  icon: '🍭',
  cost: 3,
  description: 'Equips with candy sword the target creature you control',
}
export const DEVIL_MINION = {
  type: SPELL_TYPE.DEVIL_MINION,
  name: 'Diabolo',
  targetType: SPELL_TARGET_TYPE.MY_CREATURES,
  icon: '😈',
  cost: 2,
  description: 'Gives deathtouch to target creature you control',
}
export const PETRIFY_MINION = {
  type: SPELL_TYPE.PETRIFY_MINION,
  name: 'Petri',
  targetType: SPELL_TARGET_TYPE.ENEMY_CREATURES,
  icon: '🗿',
  cost: 2,
  description: 'Petrifies target enemy creature',
}
export const FIREBALL = {
  type: SPELL_TYPE.FIREBALL,
  name: 'Ignis',
  targetType: SPELL_TARGET_TYPE.ENEMY_CREATURES,
  icon: '☄️',
  cost: 2,
  description: 'Strikes enemy creature, target is killed',
}
export const MASTER = {
  type: SPELL_TYPE.MASTER,
  name: 'Domini',
  targetType: SPELL_TARGET_TYPE.ENEMY_CREATURES,
  icon: '🧠',
  cost: 2,
  description: 'Puts target enemy creature under your control',
}

export type SpellConfig = typeof GRAVE | typeof PETRIFY_MINION | typeof DEVIL_MINION | typeof CANDY_SWORD | typeof SPARK

export class SpellObject extends GameObject {
  config: SpellConfig
  constructor(config: SpellConfig) {
    super(new Object3D())
    this.types.push(GAME_OBJECTS.SPELL)
    this.config = config
  }
}

export default {
  GRAVE,
  SPARK,
  CANDY_SWORD,
  DEVIL_MINION,
  PETRIFY_MINION,
  FIREBALL,
  MASTER,
}